// @ts-ignore
import { useEffect, useRef } from "react";
import Assistant from "../Svgs/Assistant.svg";
import usericon from "../Svgs/Usericon.svg";
import messageimage from "../Svgs/messageImage.svg";
import Avatar from "./Avatar";
import BotResponse from "./BotResponse";
import IntroSection from "./IntroSection";
import { AnimatePresence, motion } from "framer-motion";

const messageVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
};

// @ts-ignore
const ChatLog = ({ currentThread, isLoading, relatedQueries,citations, setPrompt, isSpeakerDisabled }) => {
  const chatLogEndRef = useRef(null);
  const relQref = useRef(null);

  useEffect(() => {
    if (chatLogEndRef.current) {
      // @ts-ignore
      chatLogEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [currentThread?.messages]);

  useEffect(() => {
    if (relQref.current) {
      // @ts-ignore
      relQref.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [relatedQueries]);

  if (!currentThread?.messages?.length) {
    return <IntroSection />;
  }

  return (
    <motion.div layout className="chatLogWrapper">
      <AnimatePresence initial={false}>
        {currentThread?.messages
          // @ts-ignore
          .filter((message) => message.role !== "system") // Filter out system messages
          // @ts-ignore
          .map((message, idx) => (
            <motion.div
              variants={messageVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              layout="position"
              className={`chat-message ${message.role}`}
              key={idx}
            >
              <div
                className={`messageWrapper ${message.role == "assistant" ? "justify-start" : "justify-end"
                  }`}
              >
                {message.role === "assistant" && (
                  <Avatar
                    bg={message.role === "user" ? "#4dabf7" : ""} // Light blue background
                    className={`${message.role === "user" ? "userSVG" : "botSVG"
                      } ${message.role === "assistant" ? "assistant-avatar-bg" : ""
                      }`}
                  >
                    <img
                      src={Assistant}
                      className={
                        isLoading &&
                          idx ===
                          currentThread.messages.filter(
                            // @ts-ignore
                            (m) => m.role !== "system"
                          ).length -
                          1 &&
                          message.content === ""
                          ? "rotating-icon"
                          : ""
                      }
                    />
                  </Avatar>
                )}
                <div className="message w-full">
                  {message.hasImage === true && (
                    <div className="image-indicator">
                      <img src={messageimage} style={{ marginRight: "4px" }} />
                      {message.imageName || "Image attached"}
                    </div>
                  )}
                  {message.role === "assistant" ? (
                    <BotResponse
                      response={message.content}
                      chatLogRef={chatLogEndRef}
                      isNewMessage={
                        idx ===
                        // @ts-ignore
                        currentThread.messages.filter(
                          (m) => m.role !== "system"
                        ).length -
                        1
                      }
                      isLoading={
                        isLoading &&
                        idx ===
                        currentThread.messages.filter(
                          // @ts-ignore
                          (m) => m.role !== "system"
                        ).length -
                        1
                      }
                      role={message.role}
                      citations={citations}
                    />
                  ) : (
                    <div className="userMessage">{message.content}</div>
                  )}
                </div>
                {message.role === "user" && (
                  <Avatar
                    bg={message.role === "user" ? "#4dabf7" : ""} // Light blue background
                    className={`${message.role === "user" ? "userSVG" : "botSVG"
                      } ${message.role === "assistant" ? "assistant-avatar-bg" : ""
                      }`}
                  >
                    <img src={usericon} />
                  </Avatar>
                )}
              </div>
            </motion.div>
          ))}
        {relatedQueries && relatedQueries.length > 0 && <div ref={relQref} style={{ gap: 2, padding: 5, paddingBottom: 20 }} className="messageWrapper flex flex-col items-start w-full border-t border-gray-300">
          <div className="font-bold p-2">Related queries</div>
          <div className="w-full overflow-x-scroll overflow-y-hidden flex gap-3 p-2 scrollbar-none">
            {relatedQueries && relatedQueries.map((query, index) => (
              <motion.div
                key={`rel-quer-${index}`}
                onClick={() => setPrompt(query)}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                className="flex w-fit p-2 border rounded-lg cursor-pointer pl-12 pr-3 hover:bg-[#6365f10c] relative"
              >
                <svg
                  width="100"
                  height="100"
                  viewBox="0 0 100 100"
                  xmlns="http://www.w3.org/2000/svg"
                  className="absolute -top-7 -left-7 "
                >
                  <path
                    d="M50 35L52.7143 42.9038C52.9999 43.6879 53.1428 44.0799 53.3848 44.4158C53.593 44.7032 53.8619 44.9721 54.1493 45.1803C54.4852 45.4223 54.8772 45.5652 55.6613 45.8508L63.5651 48.5651L55.6613 51.2794C54.8772 51.565 54.4852 51.7079 54.1493 51.9499C53.8619 52.1581 53.593 52.4269 53.3848 52.7143C53.1428 53.0502 52.9999 53.4422 52.7143 54.2263L50 62.1301L47.2857 54.2263C47.0001 53.4422 46.8572 53.0502 46.6152 52.7143C46.407 52.4269 46.1381 52.1581 45.8507 51.9499C45.5148 51.7079 45.1228 51.565 44.3387 51.2794L36.4349 48.5651L44.3387 45.8508C45.1228 45.5652 45.5148 45.4223 45.8507 45.1803C46.1381 44.9721 46.407 44.7032 46.6152 44.4158C46.8572 44.0799 47.0001 43.6879 47.2857 42.9038L50 35Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className='fill-[#6366f1]'
                  />
                </svg>
                <p className="text-nowrap">{query}</p>
              </motion.div>
            ))}
          </div>
        </div>}
        <div ref={chatLogEndRef} />
      </AnimatePresence>
    </motion.div>
  );
};

export default ChatLog;
